import React from "react";
import { node, object, string } from "prop-types";
import { Typography } from "@mui/material";

const LandingTitle = ({ children, variant, align, style }) => {
  return (
    <Typography
      component={variant}
      align={align}
      style={style}
      sx={(theme) => ({
        color: theme.palette.text.dark,
        fontSize: "1.2rem",
        fontWeight: "normal",
        marginBottom: "15px",
      })}
    >
      {children}
    </Typography>
  );
};

LandingTitle.defaultProps = {
  align: "left",
  variant: "p",
  style: {},
};

LandingTitle.propTypes = {
  children: node.isRequired,
  variant: string,
  align: string,
  style: object,
};

export default LandingTitle;
